var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.albumId)?_c('v-chip',{staticClass:"mt-n1",attrs:{"rounded":"","small":"","label":""}},[_vm._v(" "+_vm._s(_vm.albumId.title)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }